import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["file"];
import { splitNameAndExtension } from '../../utils/file';
import { getFileTypeFromFile } from '../../utils/fileType';
import { FileTypeIcon } from './FileTypeIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const LocalFileIcon = _ref => {
  let {
      file
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    extension
  } = splitNameAndExtension(file.name);
  const fileType = getFileTypeFromFile(file);
  return /*#__PURE__*/_jsx(FileTypeIcon, Object.assign({}, props, {
    fileType: fileType,
    extension: extension
  }));
};